// The admin support inbox tabs (12DPC-style) and how each ticket's inbox state is shown.
export const INBOX_TABS = [
  { value: 'all', label: 'All Tickets' },
  { value: 'new', label: 'New' },
  { value: 'continued', label: 'Continued Support' },
  { value: 'waiting', label: 'Waiting On Member' },
  { value: 'resolved', label: 'Resolved' },
];

export const inboxLabel = (inbox) => INBOX_TABS.find((t) => t.value === inbox)?.label || inbox;

export const inboxPillStyle = (inbox) => {
  if (inbox === 'new') return { color: '#0a0a0b', background: 'linear-gradient(180deg, #FFC20E, #FFB612)', border: '1px solid rgba(255,182,18,0.65)' };
  if (inbox === 'continued') return { color: '#FF9F43', background: 'rgba(255,159,67,0.10)', border: '1px solid rgba(255,159,67,0.50)' };
  if (inbox === 'waiting') return { color: '#9bb8ff', background: 'rgba(155,184,255,0.10)', border: '1px solid rgba(155,184,255,0.45)' };
  return { color: '#7dd87a', background: 'rgba(125,216,122,0.08)', border: '1px solid rgba(125,216,122,0.40)' };
};

export const errorMessage = (err) => {
  const detail = err?.response?.data?.detail;
  return typeof detail === 'object' ? detail?.message || detail?.code : detail || err?.message;
};
